exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pa-dashboard[data-v-d1fce862] {\n  padding: 50px;\n}\n.pa-dashboard .pvtTable[data-v-d1fce862] {\n    width: 100%;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/PADashboard.vue"],"names":[],"mappings":";AACA;EACE,cAAc;CACf;AACD;IACI,YAAY;CACf","file":"PADashboard.vue","sourcesContent":["\n.pa-dashboard[data-v-d1fce862] {\n  padding: 50px;\n}\n.pa-dashboard .pvtTable[data-v-d1fce862] {\n    width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d1fce862","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PADashboard.vue
// module id = b/Pr
// module chunks = 1